import { NgClass } from "@angular/common";
import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { Viol3Status } from "~app/common/models/constants";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ArbetsorderEventStore } from "~app/features/shared/services/arbetsorderEventStore.service";
import { IViol3status } from "./viol3status.models";

@Component({
    selector: "rask-viol3status-indicator",
    templateUrl: "./viol3status-indicator.component.html",
    styleUrls: ["./viol3status-indicator.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        RouterLink
    ]
})
export class Viol3statusIndicatorComponent implements OnInit, OnDestroy {
    @Input() arbetsorderid: number;
    viol3status: IViol3status[] = [];

    private readonly apiClientService = inject(ApiClientService);
    private readonly arbetsorderEventStore = inject(ArbetsorderEventStore);
    private readonly unsubscribe$ = new Subject<void>();

    getStyle(status: string) {
        return Viol3Status.Viol3StatusIconStyle(status);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    ngOnInit() {
        this.arbetsorderEventStore.addArbetsorderList([this.arbetsorderid]);
        this.arbetsorderEventStore.arbetsorderSynchFinished$
            .pipe(takeUntil(this.unsubscribe$))
            .pipe(filter(x => x.arbetsorderId === this.arbetsorderid))
            .subscribe(y => {
                this.refreshStatusList();
            });
        this.refreshStatusList();
    }

    private refreshStatusList() {
        const params = {
            arbetsorderId: this.arbetsorderid
        };
        this.apiClientService.get<IViol3status[]>(`Planera/GetViol3Status`, false, params).subscribe(x => {
            this.viol3status = x;
        });
    }
}
